import { connect } from 'react-redux';

import RolloutModal from './component';

const mapStateToProps = (state) => {
  const { tenantFirstName } = state.payments.landlord.property.currentTerm;
  return { tenantFirstName };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RolloutModal);
